<template>
    <accordion
        class="intergation-order text-primary"
        header-class="row m-0"
        :is-active="showDetails"
    >
        <template #header>
            <div class="col-12 d-flex flex-column flex-sm-row justify-content-between p-0">
                <span v-text="`Zgłoszenie serwisowe ${order.id}`" />
                <span
                    v-if="status"
                    v-tooltip="status.tooltip"
                    class="status w-100 mt-2 mt-sm-0"
                    :class="status.class"
                >
                    <span v-text="status.text" />
                    <a-icon v-if="status.icon" :icon="status.icon" />
                </span>
                <span v-else v-text="'---'" />
            </div>

            <div class="col-12 col-sm-10 row row-cols-1 row-cols-sm-2 row-cols-md-3 text-md">
                <div class="d-flex flex-column mb-2 mb-md-0">
                    <span v-text="'Data podjęcia'" class="typo-label" />
                    <span v-text="startedAt" />
                </div>
                <div class=" d-flex flex-column mb-2 mb-md-0">
                    <span v-text="'Data aktualizacji'" class="typo-label" />
                    <span v-text="updatedAt" />
                </div>
                <div class=" d-flex flex-column">
                    <span v-text="'Przypisany serwisant'" class="typo-label" />
                    <span v-text="order.assignedDealerEmail || '---'" />
                </div>
            </div>
        </template>

        <template #expand-button>
            <div
                class="intergation-order__expand col cursor-pointer w-100 p-0"
                @click="showDetails = !showDetails"
            >
                <span v-text="'Szczegóły'" />
                <a-icon class="pl-1" :icon="showDetails ? 'ArrowUp' : 'ArrowDown'" />
            </div>
        </template>

        <template #body>
            <div class="row">
                <span v-text="'Sklep:'" class="col-12 col-sm-5 typo-label" />
                <span v-text="locationNameAndAddress" class="col-12 col-sm-7" />
            </div>
            <div class="row">
                <span v-text="'Typ urządzenia:'" class="col-12 col-sm-5 typo-label" />
                <span v-text="order.deviceType" class="col-12 col-sm-7" />
            </div>
            <div class="row">
                <span v-text="'Liczba urządzeń:'" class="col-12 col-sm-5 typo-label" />
                <span v-text="order.upgradeDeviceCount" class="col-12 col-sm-7" />
            </div>
            <div class="row">
                <span v-text="'Twój wybór serwisu / NIP serwisu:'" class="col-12 col-sm-5 typo-label" />
                <span v-text="preferredDealer" class="col-12 col-sm-7" />
            </div>
        </template>
    </accordion>
</template>

<script>
import { STATE_LABELS } from '@/utils/constants/drs/integrations'

export default {
    props: {
        order: { type: Object, required: true }
    },

    data: () => ({
        showDetails: false
    }),

    computed: {
        status() {
            return STATE_LABELS[this.order.state]
        },

        updatedAt() {
            const dateFields = [
                'archivedAt',
                'startedAt',
                'exportedAt',
                'closedAt',
                'rejectedAt',
                'resignedAt',
                'suspendedAt',
                'dealerAssignedAt'
            ]

            const newest = Math.max(
                ...dateFields.map(key => Date.parse(this.order[key]) || 0)
            )

            return newest
                ? this.$moment(newest).format('DD-MM-YYYY')
                : '---'
        },

        startedAt() {
            return this.order.startedAt ? this.$moment(this.order.startedAt).format('DD-MM-YYYY') : '---'
        },

        locationNameAndAddress() {
            const { street, building, flat, postalCode, city } = this.order.location.address || {}
            return `${this.order.location.name}, ${street} ${building}${flat ? '/' + flat : ''}, ${postalCode} ${city}`
        },

        preferredDealer() {
            if (!this.order.preferredDealer || this.order.preferredDealer === 'undefined') {
                return 'Wybór automatyczny'
            }

            // Split the string by the last semicolon: dealerName is everything before, dealerNIP is everything after
            const str = this.order.preferredDealer
            const lastSemicolon = str.lastIndexOf(';')

            if (lastSemicolon === -1) {
                // If there's no semicolon, return the whole string as the dealer name
                return str
            }

            const dealerName = str.slice(0, lastSemicolon)
            const dealerNIP = str.slice(lastSemicolon + 1)
            return dealerNIP ? `${dealerName} / ${dealerNIP}` : dealerName
        }
    }
}
</script>

<style lang="scss">
.intergation-order {
    &__expand {
        font-size: medium;
        display: flex;
        justify-content: end;
        align-self: end;
    }
    .status {
        max-width: 9rem;
    }
    .typo-label {
        font-size: medium;
    }
    .card-body {
        gap: 0.5rem;
    }
}
</style>